import React, { useEffect } from "react";
import { ThreeDots } from "react-loader-spinner";

const ProjectCompleteNotificationModal = ({
  show,
  onConfirm,
  onCancel,
  isLoading,
}) => {
  useEffect(() => {
    if (show) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [show]);

  if (!show) return null;

  return (
    <>
      <div className="modal fade show" style={{ display: "block" }}>
        <div className="modal-dialog modal-dialog-centered modal-md">
          <div className="modal-content">
            <div className="modal-body text-center">
              <h5>
                Are you sure you want to Complete this project and push
                notification?
              </h5>
            </div>
            <div className="modal-footer justify-content-center">
              <button
                type="button"
                className={`theme-button ${isLoading ? "disabled" : ""}`}
                style={{ backgroundColor: "#d63737ff" }}
                onClick={onConfirm}
                disabled={isLoading}
              >
                {isLoading ? (
                  <ThreeDots height="20" width="100" color="white" />
                ) : (
                  "Update and Push Notification"
                )}
              </button>
              <button
                type="button"
                className="theme-button bg-grey mx-3"
                onClick={onCancel}
                disabled={isLoading}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Backdrop */}
      <div className="modal-backdrop fade show"></div>
    </>
  );
};

export default ProjectCompleteNotificationModal;
